const BlogPagination = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className="blog-pev-next-wrap">
      <ul className="list-wrap">
        <li>
          <button type="button"
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
          >
            <i className="far fa-arrow-left"></i> Previous
          </button>
        </li>
        <li className="next-post">
          <button type="button"
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
          >
            <i className="far fa-arrow-right"></i> Next
          </button>
        </li>
      </ul>
    </div>
  );
};

export default BlogPagination;
